import { computed, Ref } from 'vue'
import { useGetJobRequestedStopsQuery, useGetJobStopsQuery } from '@/api/jobs'
import { JobStopType } from '@ironsight/types'
import { inventoryAccumulate } from '@/utils/inventories'

export function useSuggestedInventory(
  jobIdRef: Ref<string>,
  requestedStopId: string | null,
  stopType: JobStopType,
) {
  const { data: requestedStops } = useGetJobRequestedStopsQuery(jobIdRef)
  const { data: actualStops } = useGetJobStopsQuery(jobIdRef)

  const suggestedPickupInventory = computed(() => {
    const actualPickupStop = actualStops.value?.find(
      (stop) => stop.requestedStopId === requestedStopId,
    )

    if (actualPickupStop) {
      return actualPickupStop.inventoryReceipts
    }

    const stop = requestedStops.value?.find((stop) => stop.id === requestedStopId)
    return stop?.inventory ?? []
  })

  const suggestedDropoffInventory = computed(() => {
    const actualDropoffStop = actualStops.value?.find(
      (stop) => stop.stopType === JobStopType.DropOff,
    )

    if (actualDropoffStop?.inventoryReceipts && actualDropoffStop?.inventoryReceipts.length > 0) {
      return actualDropoffStop.inventoryReceipts
    }

    const cumulativeRequestedInventory = inventoryAccumulate(
      requestedStops.value?.flatMap((s) => s.inventory) ?? [],
    )

    const cumulativeActualInventory = inventoryAccumulate(
      actualStops.value
        ?.filter((s) => s.stopType === JobStopType.PickUp)
        .flatMap((s) => s.inventoryReceipts) ?? [],
    )

    if (cumulativeActualInventory.length > 0) {
      return cumulativeActualInventory
    }
    return cumulativeRequestedInventory
  })

  const suggestedInventory = computed(() => {
    if (stopType === JobStopType.PickUp) {
      return suggestedPickupInventory.value
    } else if (stopType === JobStopType.DropOff) {
      return suggestedDropoffInventory.value
    } else {
      return []
    }
  })

  return { suggestedInventory }
}
